import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import StockReorderPlanningV2ReportActions from '../../Stores/StockReorderPlanningV2Report/Actions';

const { Panel } = Collapse;

class StockReorderPlanningV2ReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initStockReorderPlanningV2 } = this.props;

    if (curSiteFlowId > 0) {
      initStockReorderPlanningV2();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initStockReorderPlanningV2 } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initStockReorderPlanningV2();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'stock_reorder_planning_report_v2' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

StockReorderPlanningV2ReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initStockReorderPlanningV2: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

StockReorderPlanningV2ReportScreen.defaultProps = {
  intl: {},
  match: {},

  initStockReorderPlanningV2: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initStockReorderPlanningV2: () =>
    dispatch(
      StockReorderPlanningV2ReportActions.stockReorderPlanningV2ReportInitStockReorderPlanningV2()
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(StockReorderPlanningV2ReportScreen));
